/*
 * Radiance Veil header + collection banner + mobile menu: play promo videos only while
 * they are visible.
 *
 *  - Announcement bar: the visible slide's video/iframe plays; the others pause.
 *  - Mega menu: a tile's video plays while its panel is open and pauses when it closes.
 *  - Mobile menu promo: its video plays while the drawer is open and pauses when it closes.
 *  - Collection banner: always visible once on the page, so its video just plays once.
 *
 * Videos are muted, looping and inline (rv-media snippet). Nothing autoplays from markup, so hidden
 * videos never download or play. Visitors with "reduce motion" see the poster/image instead.
 */
(function () {
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function activate(root) {
    if (reduceMotion) return;
    root.querySelectorAll('iframe[data-rv-iframe]').forEach(function (frame) {
      if (!frame.getAttribute('src')) frame.setAttribute('src', frame.getAttribute('data-src'));
    });
    root.querySelectorAll('video[data-rv-video]').forEach(function (video) {
      video.muted = true;
      var played = video.play();
      if (played && played.catch) played.catch(function () {});
    });
  }

  function deactivate(root) {
    root.querySelectorAll('video[data-rv-video]').forEach(function (video) {
      video.pause();
    });
    root.querySelectorAll('iframe[data-rv-iframe]').forEach(function (frame) {
      if (frame.getAttribute('src')) frame.removeAttribute('src');
    });
  }

  /* ---------- announcement bar ---------- */
  function syncAnnouncement(bar) {
    bar.querySelectorAll('.announcement-bar__item--media').forEach(function (slide) {
      if (slide.closest('.ui-overlap-item-clones')) return;
      if (slide.hasAttribute('inert')) {
        deactivate(slide);
      } else {
        activate(slide);
      }
    });
  }

  // Slider bars under the stacked phone bar (announcement-bar.liquid): the current announcement's bar
  // is dark and fills over the autoplay time; tapping a bar goes to that announcement.
  // Phones (stacked style) use their own time per announcement ("Time per announcement (phones)").
  var PHONE = window.matchMedia('(max-width: 719px)');
  function applyDelay(bar) {
    var progress = bar.querySelector('[data-rv-ann-progress]');
    var swiperEl = bar.querySelector('.swiper');
    var swiper = swiperEl && swiperEl.swiper;
    if (!progress || !swiper || !swiper.autoplay || !swiper.params || !swiper.params.autoplay) return;
    var desktopDelay = parseInt(swiperEl.getAttribute('data-autoplay-delay'), 10) || 4000;
    var mobileDelay = parseInt(progress.getAttribute('data-delay-mobile'), 10) || 6000;
    var delay = PHONE.matches && bar.getAttribute('data-mobile-style') === 'stacked' ? mobileDelay : desktopDelay;
    if (swiper.__rvDelay === delay) return;
    swiper.__rvDelay = delay;
    if (typeof swiper.params.autoplay === 'object') swiper.params.autoplay.delay = delay;
    swiperEl.querySelectorAll('.swiper-slide').forEach(function (slide) {
      slide.setAttribute('data-swiper-autoplay', delay);
    });
  }

  function syncProgress(bar) {
    applyDelay(bar);
    var progress = bar.querySelector('[data-rv-ann-progress]');
    if (!progress) return;
    var slides = Array.prototype.filter.call(bar.querySelectorAll('.swiper [data-slide]'), function (slide) {
      return !slide.closest('.ui-overlap-item-clones');
    });
    var current = bar.querySelector('.swiper .swiper-slide-active[data-slide]') ||
      slides.filter(function (slide) { return !slide.hasAttribute('inert'); })[0];
    var index = current ? parseInt(current.getAttribute('data-index'), 10) || 0 : 0;
    if (progress.__rvIndex === index) return;
    progress.__rvIndex = index;
    progress.querySelectorAll('.rv-ann-progress__seg').forEach(function (seg, i) {
      seg.classList.toggle('is-active', i === index);
      seg.classList.remove('is-running');
    });
    var active = progress.querySelectorAll('.rv-ann-progress__seg')[index];
    if (active) {
      void active.offsetWidth; // restart the fill animation
      active.classList.add('is-running');
    }
  }

  function initProgress(bar) {
    var progress = bar.querySelector('[data-rv-ann-progress]');
    if (!progress || progress.__rvBound) return;
    progress.__rvBound = true;
    progress.addEventListener('click', function (event) {
      var seg = event.target.closest('.rv-ann-progress__seg');
      if (!seg) return;
      var index = parseInt(seg.getAttribute('data-index'), 10) || 0;
      var swiperEl = bar.querySelector('.swiper');
      var swiper = swiperEl && swiperEl.swiper;
      if (!swiper) return;
      if (swiper.params && swiper.params.loop && swiper.slideToLoop) swiper.slideToLoop(index);
      else swiper.slideTo(index);
    });
    progress.__rvIndex = -1;
    syncProgress(bar);
    // the slider may still be starting up; apply the phone timing once it's ready
    var tries = 0;
    (function waitForSlider() {
      var swiperEl = bar.querySelector('.swiper');
      if (swiperEl && swiperEl.swiper) applyDelay(bar);
      else if (++tries < 40) setTimeout(waitForSlider, 250);
    })();
    if (PHONE.addEventListener) PHONE.addEventListener('change', function () { applyDelay(bar); });
  }

  function initAnnouncement(bar) {
    if (bar.__rvAnnObserver) bar.__rvAnnObserver.disconnect();
    var queued = false;
    var observer = new MutationObserver(function () {
      if (queued) return;
      queued = true;
      requestAnimationFrame(function () {
        queued = false;
        syncAnnouncement(bar);
        syncProgress(bar);
      });
    });
    observer.observe(bar, {
      attributes: true,
      attributeFilter: ['inert', 'class'],
      childList: true,
      subtree: true
    });
    bar.__rvAnnObserver = observer;
    syncAnnouncement(bar);
    initProgress(bar);
  }

  /* ---------- mega menu panels ---------- */
  function initHeader(header) {
    if (header.__rvMegaObserver) header.__rvMegaObserver.disconnect();
    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (m) {
        var el = m.target;
        if (!el.classList || !el.classList.contains('meganav')) return;
        if (el.classList.contains('active')) {
          activate(el);
        } else {
          deactivate(el);
        }
      });
    });
    observer.observe(header, { attributes: true, attributeFilter: ['class'], subtree: true });
    header.__rvMegaObserver = observer;
  }

  /* ---------- mobile menu promo (drawer-menu.liquid) ---------- */
  function initDrawer(drawer) {
    if (drawer.__rvDrawerObserver) drawer.__rvDrawerObserver.disconnect();
    var promo = drawer.querySelector('.drawer-menu__promo .rv-media');
    if (!promo) return;
    var observer = new MutationObserver(function () {
      if (drawer.classList.contains('active') || drawer.classList.contains('visible')) {
        activate(promo);
      } else {
        deactivate(promo);
      }
    });
    observer.observe(drawer, { attributes: true, attributeFilter: ['class'] });
    drawer.__rvDrawerObserver = observer;
  }

  function init() {
    document.querySelectorAll('.announcement-bar').forEach(initAnnouncement);
    document.querySelectorAll('header[data-section-type="header"]').forEach(initHeader);
    document.querySelectorAll('.drawer-menu').forEach(initDrawer);
    // Collection banners are static (always visible, no open/close state), so their video
    // just activates once rather than needing the show/hide tracking the other two need.
    document.querySelectorAll('.collection-banner .rv-media').forEach(activate);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // theme editor: sections re-render without a page load
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:block:select', function (event) {
    var bar = event.target && event.target.closest && event.target.closest('.announcement-bar');
    if (bar) syncAnnouncement(bar);
  });

  // pause everything when the tab is hidden, resume the visible slide when it comes back
  document.addEventListener('visibilitychange', function () {
    if (document.hidden) {
      document.querySelectorAll('.announcement-bar, .meganav, .drawer-menu').forEach(deactivate);
    } else {
      document.querySelectorAll('.announcement-bar').forEach(syncAnnouncement);
      document.querySelectorAll('.meganav.active').forEach(activate);
      document.querySelectorAll('.drawer-menu.active, .drawer-menu.visible').forEach(activate);
    }
  });
})();

/* Mobile menu close button (snippets/drawer-menu.liquid): the pop-up menu covers the header's
   menu button, so it has its own. Same as tapping the overlay, which the theme's drawer JS closes on. */
(function () {
  document.addEventListener('click', function (event) {
    var button = event.target.closest && event.target.closest('[data-rv-drawer-close]');
    if (!button) return;
    event.preventDefault();
    var overlay = button.closest('.drawer-menu') && button.closest('.drawer-menu').querySelector('[data-overlay]');
    if (overlay) overlay.click();
  });
})();

/*
 * Track Your Order links (sections/header.liquid utility bar, snippets/drawer-menu.liquid): open the
 * Track Your Order pop-up (snippets/rv-track-modal.liquid, assets/rv-support.js). From the mobile
 * menu, the menu closes first.
 */
(function () {
  function fromDrawer(link, run) {
    var drawer = link.closest('.drawer-menu');
    if (drawer && drawer.classList.contains('active')) {
      var overlay = drawer.querySelector('[data-overlay]');
      if (overlay) overlay.click();
      setTimeout(run, 400);
      return true;
    }
    return false;
  }

  document.addEventListener('click', function (event) {
    var link = event.target.closest && event.target.closest('[data-rv-track-order]');
    if (!link || !window.rvTrack) return;
    event.preventDefault();
    if (!fromDrawer(link, window.rvTrack.open)) window.rvTrack.open();
  });
})();


/*
 * Sign-in pop-up (Shopify's <shopify-account>) + one login for the store and Veil Points/Wishlist.
 * Both use the store's customer login; this keeps every
 * way of signing in on the same pop-up and keeps open pages in step:
 *   - Desktop: the sign-in pop-up and the signed-in account menu ("Hi, ...") open centered on the page
 *     (Shopify pins them to the top right) and a little wider, over a soft dimmed backdrop. They live in
 *     an open shadow root, so a small style goes in.
 *   - "Sign in" / "Join" links to the store login anywhere on the page (e.g. inside the Veil Points
 *     or wishlist panel) open the same pop-up instead of leaving for the login page.
 *   - Signing in or out in another tab (or the Shop app's browser) is picked up when the shopper comes
 *     back to this tab: the page reloads once so the store, Veil Points, Wishlist and chat all switch
 *     together (templates/index.rv-session.liquid says who is signed in). Only on a real tab switch,
 *     and never after the shopper used the pop-up on this page: Shopify finishes that sign-in itself,
 *     and a second reload on top of it made shoppers sign in twice.
 */
(function () {
  var customer = window.rvCustomer || {};
  var usedPopup = false;                                    // signed in/out with the pop-up on this page
  // Signed in with Shop, the avatar is Shopify's 3D "coin", and Chrome hit-tests that 3D layer far
  // past the 28px icon: clicks across most of the desktop search bar landed on the avatar and opened
  // the "Hi, ..." panel. Paint containment keeps its clickable area to the icon itself (the panel
  // opens in the top layer, so it isn't clipped).
  var COIN_FIX = '.account-button { contain: paint; }';
  var SIGNIN_STYLE = [
    '@media (min-width: 751px) {',
    '  .dialog { inset: 0 !important; margin: auto !important; height: fit-content !important;',
    '    width: min(440px, calc(100vw - 48px)) !important; max-width: 440px !important; }',
    '  .dialog::backdrop { background: rgba(43, 40, 38, 0.35) !important; }',
    '  .account { max-height: calc(100dvh - 48px) !important; }',
    '}'
  ].join('\n');

  // "Sign out" (last item of the account menu, links to /account/logout): a soft, centered, muted row under the
  // menu items, no box; darkens on hover (user, 2026-10-13: "nicer and softer").
  var SIGNOUT_STYLE = [
    'li:has(> a[href*="/account/logout"]), *:has(> a[href*="/account/logout"]):not(ul):not(nav) { border-bottom: 0 !important; background: none !important; }',
    'a[href*="/account/logout"], a[href*="/account/logout"] * { justify-content: center !important; text-align: center !important; }',
    'a[href*="/account/logout"] { display: flex !important; align-items: center !important; width: 100% !important; box-sizing: border-box !important;',
    '  margin: 0 !important; padding: 16px 16px 14px !important; border: 0 !important; background: none !important; box-shadow: none !important;',
    '  color: #8c8582 !important; font-size: 11.5px !important; font-weight: 400 !important; letter-spacing: 0.16em !important;',
    '  text-transform: uppercase !important; text-decoration: none !important; transition: color 0.2s ease !important; }',
    'a[href*="/account/logout"]:hover, a[href*="/account/logout"]:focus-visible { color: #2b2826 !important; background: none !important; }'
  ].join('\n');

  // Account menu items (Profile, My Orders, ...) in the store's menu style: small, uppercase, letter-spaced.
  // Matched by their links, since Shopify draws its own markup around them.
  var MENU_LINKS = ['a[href*="/apps/rv/account"]', 'a[href*="account.radianceveil.com"]'];
  var MENU_STYLE = [
    MENU_LINKS.join(', ') + ' { font-size: 12.5px !important; font-weight: 400 !important; letter-spacing: 0.12em !important;',
    '  text-transform: uppercase !important; color: #2b2826 !important; }',
    MENU_LINKS.map(function (x) { return x + ' *'; }).join(', ') + ' { font: inherit !important; letter-spacing: inherit !important; text-transform: inherit !important; color: inherit !important; }',
    MENU_LINKS.map(function (x) { return x + ':hover'; }).join(', ') + ' { color: #6b5d58 !important; }',
    // "Store credit $X · Veil Points N" line under the email (added by addWallet below)
    '.rv-acct-wallet { margin: 6px 0 0; font-size: 13px; letter-spacing: 0.02em; color: #6b5d58; }',
    '.rv-acct-wallet strong { color: #2b2826; font-weight: 500; }',
    '.rv-acct-wallet span { margin: 0 8px; color: #cfc6c3; }'
  ].join('\n');

  // Signed out, Shopify still lists the account menu (Profile ... Sign out) under the sign-in form. While the
  // sign-in form is showing, that menu is hidden and a short "why sign in" note takes its place (addPerks);
  // once signed in the form is gone, so the menu shows again and the note hides (user, 2026-10-13).
  var SIGNED_OUT_STYLE = [
    '.account__content:has(shopify-login-form-loader, shopify-login-form) .account__menu-region { display: none !important; }',
    '.rv-signin-perks { display: none; }',
    '.account__content:has(shopify-login-form-loader, shopify-login-form) .rv-signin-perks { display: block; }',
    '.rv-signin-perks { margin: 6px 0 4px; padding: 20px 4px 2px; border-top: 1px solid #ece6e3; text-align: center; font-family: Urbanist, sans-serif; }',
    '.rv-signin-perks__title { margin: 0 0 12px; font-size: 11.5px; font-weight: 500; letter-spacing: 0.16em; text-transform: uppercase; color: #6b5d58; }',
    '.rv-signin-perks ul { list-style: none; margin: 0; padding: 0; }',
    '.rv-signin-perks li { margin: 0 0 7px; font-size: 13.5px; line-height: 1.45; letter-spacing: 0.01em; color: #2b2826; }',
    '.rv-signin-perks li::before { content: "\\2661"; margin-right: 8px; color: #b76e79; font-size: 12px; }',
    // The sign-in form in the store text (Shop's purple button is Shop's own and stays as is): letter-spaced caps
    // heading, square inputs and buttons in the store's warm grays.
    '.account__heading { font-family: Urbanist, sans-serif !important; font-size: 15px !important; font-weight: 400 !important;',
    '  letter-spacing: 0.16em !important; text-transform: uppercase !important; color: #2b2826 !important; }',
    '.login-form__divider-text { font-size: 11px !important; letter-spacing: 0.16em !important; color: #8c8582 !important; }',
    '.login-form__email-input { border-radius: 0 !important; background: #ffffff !important; border: 1px solid #d9d1ce !important; box-shadow: none !important; }',
    '.login-form__email-input:focus { border-color: #8c8582 !important; }',
    '.login-form__email-label { font-size: 14px !important; letter-spacing: 0.02em !important; color: #8c8582 !important; }',
    // Ticked by default: signing up joins the same email list as the 10% off sign-up
    '.login-form__marketing-consent-label { font-size: 0 !important; }',
    '.login-form__marketing-consent-label::after { content: "Email me exclusive offers + 10% off my first order"; font-size: 13.5px; letter-spacing: 0.01em; color: #2b2826; }',
    'button.secondary, .button.secondary { border-radius: 0 !important; background: #ffffff !important; border: 1px solid #d9d1ce !important;',
    '  font-family: Urbanist, sans-serif !important; font-size: 12px !important; letter-spacing: 0.16em !important; text-transform: uppercase !important; color: #4a4340 !important; }',
    'button.secondary:hover, .button.secondary:hover { border-color: #8c8582 !important; color: #2b2826 !important; }'
  ].join('\n');

  // Signed in or out, the pop-up (sign-in or the "Hi, ..." account menu) opens centered (user, 2026-10-13).
  var STYLE = COIN_FIX + '\n' + SIGNIN_STYLE + '\n' + MENU_STYLE + '\n' + SIGNOUT_STYLE + '\n' + SIGNED_OUT_STYLE;

  // The account pop-up can draw parts of itself in nested shadow roots, so the style goes into each of them.
  function styleRoot(root) {
    // (":scope >" matches nothing on a shadow root, so check the direct children; it added a copy on every page change)
    if (!Array.prototype.some.call(root.children, function (c) { return c.matches('style[data-rv-account]'); })) {
      var style = document.createElement('style');
      style.setAttribute('data-rv-account', '');
      style.textContent = STYLE;
      root.appendChild(style);
    }
    root.querySelectorAll('*').forEach(function (el) { if (el.shadowRoot) styleRoot(el.shadowRoot); });
  }
  function styleAccounts() {
    document.querySelectorAll('shopify-account').forEach(function (el) {
      if (el.shadowRoot) { styleRoot(el.shadowRoot); addWallet(el.shadowRoot); addPerks(el.shadowRoot); }
    });
  }

  // Signed in: "Store credit $X · Veil Points N" under the email at the top of the account pop-up.
  // Store credit comes from Shopify (header.liquid), points from the Veil Points summary (/apps/rv/points).
  var walletPoints = null;
  function loadPoints() {
    if (walletPoints !== null || !customer.id) return;
    walletPoints = '';
    fetch('/apps/rv/points', { credentials: 'same-origin' }).then(function (r) { return r.json(); })
      .then(function (d) { walletPoints = d && d.signedIn ? String(d.points) : '0'; styleAccounts(); })
      .catch(function () { walletPoints = null; });
  }
  function addWallet(root) {
    if (!customer.id || !customer.email) return;
    loadPoints();
    var email = String(customer.email).toLowerCase(), found = null;
    (function walk(r) {
      r.querySelectorAll('*').forEach(function (n) {
        if (found) return;
        if (n.shadowRoot) walk(n.shadowRoot);
        if (!n.children.length && n.textContent.trim().toLowerCase() === email) found = n;
      });
    })(root);
    if (!found) return;
    var box = found.parentNode.querySelector('.rv-acct-wallet');
    if (!box) {
      box = document.createElement('p');
      box.className = 'rv-acct-wallet';
      found.after(box);
      var host = found.getRootNode();
      if (host && host.querySelector && !host.querySelector('style[data-rv-account]')) styleRoot(host);
    }
    box.innerHTML = 'Store credit <strong></strong><span>·</span>Veil Points <strong></strong>';
    var b = box.querySelectorAll('strong');
    b[0].textContent = customer.storeCredit || '$0.00';
    b[1].textContent = walletPoints || '…';
  }
  // Signed out: what an account gets you, under the sign-in form (shown only while the form is there).
  function addPerks(root) {
    // Members already have these perks, so signed-in customers never see the list (and any left over is removed).
    if (customer.id) { (function rm(r) { r.querySelectorAll('.rv-signin-perks').forEach(function (b) { b.remove(); }); r.querySelectorAll('*').forEach(function (n) { if (n.shadowRoot) rm(n.shadowRoot); }); })(root); return; }
    (function walk(r) {
      r.querySelectorAll('.account__login-slot').forEach(function (slot) {
        if (slot.parentNode.querySelector(':scope > .rv-signin-perks')) return;
        var box = document.createElement('div');
        box.className = 'rv-signin-perks';
        box.innerHTML = '<p class="rv-signin-perks__title">Join the Veil community</p><ul>' +
          '<li>Exclusive offers and member-only discounts</li>' +
          '<li>First access to new drops</li>' +
          '<li>50 Veil Points to start, plus 50 every birthday</li>' +
          '<li>Earn Veil Points toward money off your orders</li></ul>';
        slot.after(box);
      });
      r.querySelectorAll('*').forEach(function (n) { if (n.shadowRoot) walk(n.shadowRoot); });
    })(root);
  }

  styleAccounts();
  if (window.customElements && customElements.whenDefined) {
    customElements.whenDefined('shopify-account').then(function () { setTimeout(styleAccounts, 0); });
  }
  new MutationObserver(styleAccounts).observe(document.documentElement, { childList: true, subtree: true });

  // The pop-up can only show from a <shopify-account> that is on screen: the header one on desktop.
  // On phones it sits in the closed menu drawer, so links fall back to the store's sign-in page.
  function accountElement() {
    var all = Array.prototype.slice.call(document.querySelectorAll('shopify-account'));
    return all.filter(function (el) { return el.getClientRects().length > 0; })[0] || null;
  }

  // Opens the sign-in pop-up; false if it isn't available (the link then works as usual).
  function openSignIn() {
    var el = accountElement();
    if (!el || typeof el.showModal !== 'function') return false;
    styleAccounts();
    usedPopup = true;
    el.showModal();
    return true;
  }
  window.rvOpenSignIn = openSignIn;

  var LOGIN_LINK = /\/(account\/login|account\/register|customer_authentication\/login)(\b|\?|$)/;

  // Signed in: tapping the account icon (header or phone menu) goes straight to the full My Account page instead of
  // the small pop-up. Clicks inside an already-open pop-up are left alone. Signed out, the sign-in pop-up opens as before.
  function popupOpen(el) {
    if (el.open) return true;
    var sr = el.shadowRoot;
    return !!(sr && sr.querySelector('dialog[open], [open]'));
  }
  document.addEventListener('click', function (event) {
    if (!customer.id || event.metaKey || event.ctrlKey) return;
    var path = event.composedPath ? event.composedPath() : [event.target];
    // The phone menu's "My Account" label is outside the component (the theme forwards its clicks), so it counts too.
    var acct = path.filter(function (node) { return node && (node.tagName === 'SHOPIFY-ACCOUNT' || (node.matches && node.matches('[data-list-item]') && node.querySelector('shopify-account'))); })[0];
    if (acct && acct.tagName !== 'SHOPIFY-ACCOUNT') acct = acct.querySelector('shopify-account');
    if (!acct || popupOpen(acct)) return;
    event.preventDefault();
    event.stopPropagation();
    window.location.href = '/apps/rv/account';
  }, true);

  document.addEventListener('click', function (event) {
    var path = event.composedPath ? event.composedPath() : [event.target];
    if (path.some(function (node) { return node && node.tagName === 'SHOPIFY-ACCOUNT'; })) {
      usedPopup = true;
      [0, 150, 500].forEach(function (ms) { setTimeout(styleAccounts, ms); });   // the menu is drawn after the click
    }
    if (customer.id || event.defaultPrevented) return;
    var link = null;
    for (var i = 0; i < path.length; i++) {
      var node = path[i];
      if (!node || !node.tagName) continue;
      if (node.tagName === 'SHOPIFY-ACCOUNT') return;        // the pop-up's own links
      if (!link && node.tagName === 'A' && LOGIN_LINK.test(node.getAttribute('href') || '')) link = node;
    }
    if (!link) return;
    if (openSignIn()) {
      event.preventDefault();
      event.stopPropagation();
    }
  }, true);

  // Signed in/out somewhere else: reload this tab once so everything matches.
  if (window.Shopify && window.Shopify.designMode) return;
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var current = customer.id ? String(customer.id) : '';
  var checking = false;
  var lastCheck = 0;

  function checkSession() {
    if (usedPopup || checking || document.visibilityState === 'hidden' || Date.now() - lastCheck < 4000) return;
    checking = true;
    lastCheck = Date.now();
    fetch(root + '?view=rv-session', { credentials: 'same-origin', cache: 'no-store' })
      .then(function (response) { return response.ok ? response.text() : null; })
      .then(function (text) {
        if (text === null) return;
        var id = text.trim();
        if (!/^\d*$/.test(id) || id === current) return;
        var key = 'rv-session-reloaded';
        var done = '';
        try { done = sessionStorage.getItem(key) || ''; } catch (e) {}
        if (done === id) return;                             // already reloaded for this change
        try { sessionStorage.setItem(key, id); } catch (e) {}
        window.location.reload();
      })
      .catch(function () {})
      .then(function () { checking = false; });
  }
  try { if (sessionStorage.getItem('rv-session-reloaded') === current) sessionStorage.removeItem('rv-session-reloaded'); } catch (e) {}

  document.addEventListener('visibilitychange', checkSession);
  window.addEventListener('pageshow', function (event) { if (event.persisted) checkSession(); });
})();
